export const BILLING_HANDSHAKE_MODAL = 'BILLING_HANDSHAKE_MODAL'
export const VISIT_ENDED_MODAL = 'VISIT_ENDED_MODAL'
export const INVALID_BROWSER_MODAL = 'INVALID_BROWSER_MODAL'
export const CAMERA_ERROR_MODAL = 'CAMERA_ERROR_MODAL'
export const AUDIO_ERROR_MODAL = 'AUDIO_ERROR_MODAL'
export const SPEED_ERROR_MODAL = 'SPEED_ERROR_MODAL'
export const VISIT_UNCONNECTED_MODAL = 'VISIT_UNCONNECTED_MODAL'
export const SEND_MESSAGE_MODAL = 'SEND_MESSAGE_MODAL'
export const BREAK_IN_WARNING_MESSAGE_MODAL = 'BREAK_IN_WARNING_MESSAGE_MODAL'
